<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">办公系统</el-breadcrumb-item>
        <el-breadcrumb-item>流程申请</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-divider content-position="left">财务流程</el-divider>
    <el-row style="min-width:320px">
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('expense')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #67c23a;">
              <Ticket />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>费用报销单</p>
          </div>
          <div class="el-result__subtitle">
            <p>适用于申请人已垫资产生花销的费用</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('payreceipt')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #e6a23c;">
              <Money />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>请款申请单</p>
          </div>
          <div class="el-result__subtitle">
            <p>适用于对外部要付款的费用项</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('loanapply')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #f56c6c;">
              <Wallet />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>借/还款申请单</p>
          </div>
          <div class="el-result__subtitle">
            <p>可先进行费用借款申请，后续还款。</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('bookkeep')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(194, 0, 232);">
              <CircleCheck />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>内部往来记账</p>
          </div>
          <div class="el-result__subtitle">
            <p>财务部使用流程，一般仅财务使用</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('payback')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(0, 143, 108);">
              <CreditCard />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>收支确认单</p>
          </div>
          <div class="el-result__subtitle">
            <p>渠道订单回款/退差价等打款到公司账户</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('equally')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: gold;">
              <DocumentCopy />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>费用分摊单据</p>
          </div>
          <div class="el-result__subtitle">
            <p>各部门的公共分摊费用，如水电及其他等</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('material')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #000;">
              <Medal />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>金料付款单</p>
          </div>
          <div class="el-result__subtitle">
            <p>专适用于金料购买的付款流程</p>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-divider content-position="left">OA办公流程</el-divider>
    <el-row style="min-width:320px;">
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('sealapply')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color:#67c23a;">
              <Stamp />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>印章使用申请</p>
          </div>
          <div class="el-result__subtitle">
            <p>按规定填写申请表并提交相关需印章的文件，经审核后方可使用印章</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('hrleave')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(69, 52, 254);">
              <Moon />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>请假申请单</p>
          </div>
          <div class="el-result__subtitle">
            <p>适用于病假/产假/调休/婚假等休假情况</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('hrovertime')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(11, 168, 0);">
              <OfficeBuilding />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>加班申请单</p>
          </div>
          <div class="el-result__subtitle">
            <p>适用于日常加班/节假日加班等情况</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('hrnosign')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(255, 0, 0);">
              <AddLocation />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>补卡申请单</p>
          </div>
          <div class="el-result__subtitle">
            <p>适用于上下班漏卡等情况</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openFlowPage('hrouting')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(68 63 169);">
              <LocationFilled />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>外出申请单</p>
          </div>
          <div class="el-result__subtitle">
            <p>适用于外出办公等情况</p>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  name: "application",
  components: {},
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    openFlowPage(page) {
      this.$router.push("flowForm?page=" + (page || ""))
    }
  },
};
</script>
<style scoped>
.el-result {
  margin: 0 12px;
  border: 1px solid #fff;
  --el-result-padding: 10px;
  --el-result-title-margin-top:10px;
  --el-result-icon-font-size:null;
  background: #fcfcfc;
}

.el-result:hover {
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
}

.el-divider >>> .el-divider__text{font-size: 18px;}
</style>